import React from "react";

import "firebase/database";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

function BotDetails(props) {
  const getBotVolumeNprofit = (id) => {
    var x;
    var obj = {};
    for (x in props.volumeNprofitData) {
      if (props.volumeNprofitData[x].key === id) {
        obj = props.volumeNprofitData[x];
        return props.volumeNprofitData[x];
      }
    }
    return obj;
  };
  const getPendingOrders = (id) => {
    var x;
    var count = 0;
    for (x in props.pendingOrders) {
      if (props.pendingOrders[x].key === id) {
        count = props.pendingOrders[x].data.length;
        return props.pendingOrders[x].data.length;
      }
    }
    return count;
  };

  const renderRow = (item, key) => {
    var volumeNprofit = getBotVolumeNprofit(item.id);
    // console.log("inside");
    return (
      <div
        style={
          item.type === "BUY"
            ? { minWidth: "950px", backgroundColor: "#3d4142" }
            : { minWidth: "950px", backgroundColor: "#252728" }
        }
        key={key}
        className="row  text-center border-secondary  border-bottom"
      >
        <div className="col-4">
          <div className="row">
            <div className="col-3 py-1 px-1   border-secondary  border-left tooltipMy">
              <Link
                type="button"
                className="px-1 btn-dark w-100 py-1 text-truncate "
                to={"/account/bot/" + item.id}
                style={{
                  borderRadius: "10px",
                  fontSize: "0.9rem",
                  color: "#bdc0c2",
                  backgroundColor: "black",
                }}
              >
                {item.name && item.name.length > 0 ? item.name : item.displayId}
              </Link>
              <div
                className="tooltiptextmy text-center"
                style={{
                  width: "9rem",
                  marginLeft: "1rem",
                  backgroundColor: "black",
                  // padding: "5px",
                }}
              >
                <span>
                  {item.name && item.name.length > 0
                    ? item.name
                    : item.displayId}
                  <br />
                </span>
                <button
                  onClick={() => props.createACopyofBot(item)}
                  type="button"
                  className="btn btn-dark btn-sm mt-1"
                >
                  Create a Copy
                </button>
              </div>
            </div>
            <div
              className="col-2 py-2  overflow-hidden px-1 border-secondary  border-left text-uppercase"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {!(
                item.strategy.name === "MARKET-MAKER" ||
                item.strategy.name === "MARKET-MAKER-RSI" ||
                item.strategy.name === "EMA-MA-CROSSOVER"
              )
                ? item.type
                : "-"}
            </div>
            <div
              className="col-2 py-2  overflow-hidden px-1 border-secondary  border-left text-uppercase"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {!(
                item.strategy.name === "MARKET-MAKER" ||
                item.strategy.name === "MARKET-MAKER-RSI" ||
                item.strategy.name === "EMA-MA-CROSSOVER"
              )
                ? item.dcaOrGrid
                : "-"}
            </div>
            <div
              className="col-3 py-2  overflow-hidden px-1 border-secondary  border-left text-uppercase"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {item.market}
            </div>
            <div
              className="col-2 py-2  overflow-hidden px-1 border-secondary  border-left text-uppercase"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {item.strategy.name
                .match(/\b(\w)/g)
                .join("")
                .toUpperCase()}
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="row">
            <div
              className="col-3 py-2 px-1  overflow-hidden  border-secondary  border-left"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {item.takeProfit}
            </div>
            <div
              className="col-3 py-2  overflow-hidden px-1 border-secondary  border-left text-uppercase"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {item.isStopLossSet ? item.stopLoss : "-"}
            </div>
            <div
              className="col-3 py-2  overflow-hidden px-1 border-secondary  border-left text-uppercase"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {getPendingOrders(item.id) ? getPendingOrders(item.id) : 0}
            </div>
            <div
              className="col-3 py-2  overflow-hidden px-1 border-secondary  border-left text-uppercase"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {item.orderSize}
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="row">
            <div
              className="col-3 py-2 px-1 border-secondary  border-left"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {volumeNprofit.bottodayProfit
                ? volumeNprofit.bottodayProfit.toFixed(2)
                : 0}
            </div>
            <div
              className="col-4 py-2 px-1 border-secondary  border-left"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {volumeNprofit.bottodayVolume
                ? volumeNprofit.bottodayVolume.toFixed(2)
                : 0}
            </div>
            <div
              className="col-2 py-2 px-1 border-secondary  border-left"
              style={{
                fontSize: "0.9rem",
                color: "#bdc0c2",
              }}
            >
              {volumeNprofit.bottodayVolume
                ? (
                    (volumeNprofit.bottodayProfit /
                      volumeNprofit.bottodayVolume) *
                    100
                  ).toFixed(2)
                : 0}
            </div>
            <div className="col-3 py-1 border-secondary  border-left  border-right px-0">
              <button
                className="btn btn-danger mx-0 btn-sm"
                onClick={() => {
                  props.stopActiveBot(item.id, item.displayId);
                }}
              >
                Stop
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  if (props.type === "ACTIVE" && props.data.length > 0) {
    return <div>{props.data.map((item, key) => renderRow(item, key))}</div>;
  } else {
    return (
      <div
        style={{ minWidth: "950px" }}
        className="row  text-center border-secondary  border-bottom border-left  border-right "
      >
        <div className="col-12 text-center">No Active Bots.</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  volumeNprofitData: state.volumeNprofit.data,
  pendingOrders: state.pendingOrders.data,
});

export default connect(mapStateToProps)(BotDetails);
